import axios from "axios";
import API_BASE_URL from "./apiConfig";

// Login API call
export const updateClientLatLong = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/clients/update-coordinates`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getAllClients = async (request) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/clients/getAllClients`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getAllClientsByLogisId = async (logisticId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/clients/getClientsByLogistic`,
      {
        params: { logisticId }, // ✅ Pass as query param
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getAllEmployees = async (request) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/employees/getAllEmployees`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const getAllCentre = async (request) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/centre/getAllCentre`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const createCenter = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/centre/create`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const updateCenter = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/centre/update`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const createEmployee = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/employees/create`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const updateEmployee = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/employees/update`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const createClients = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/clients/create`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const updateClient = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/clients/updateClient`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const createSlot = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/slot/create`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const getAllSlot = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/slot/allSlots`);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const updateSlot = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/slot/update`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const creatTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/create`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const clientTaskCreate = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/client-task/create`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const updateOperationTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/update`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const getAssignedTasks = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/getAssignedTasks`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateClientTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/client-task/update`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getAllClientTask = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/client-task/getAllClientTask`);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// export const getAllTask = async () => {
//   try {
//     const response = await axios.get(`${API_BASE_URL}/operation/task/getAllTask`);
//     return response.data; // return API response
//   } catch (error) {
//     throw error.response ? error.response.data : error;
//   }
// };

export const getAllTask = async (createdById) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/operation/task/getAllTask`,
      {
        params: { createdById }, // ✅ Pass as query param
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};


export const getAllTaskFiles = async (taskId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/operation/task/files/${taskId}`);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const getClientById = async (clientId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/clients/getClientById/${clientId}`);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getCentreById = async (centreId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/centre/getCentreById/${centreId}`);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const assignTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/assign`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const cancelOperationTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/cancel`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const cancelClientTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/client-task/cancel`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const taskAccepted = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/logisticStatus/update`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const taskReject = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/logisticStatus/update`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const startTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/startTask`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const collectTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/collect`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const handoverTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/handover`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const completedTask = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/complete-task`, request);
    return response; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const downloadReport = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/operation/task/download-report`, request);
    return response; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
